// @ts-nocheck: converted from JS

import Create from '@/components/Glossary/Sections/Requests/Create';
import Edit from '@/components/Glossary/Sections/Requests/Edit';
import { Routes, Route } from 'react-router-dom';
import Show from './Show';

const Requests = () => {
  return (
    <div className="ph4">
      <Routes>
        <Route path="/" element={<Show />} />
        <Route path="/create" element={<Create />} />
        <Route path="/:requestTemplate/edit" element={<Edit />} />
      </Routes>
    </div>
  );
};

export default Requests;
